export default {
  totalServiceTime: {
    label: 'fields.engineering.commutator-maintenance.total-service-time',
    required: true,
    min: 0,
    max: 20000,
    maxLength: 5,
    maxLengthMask: 6,
  },
  performedMaintenanceNumber: {
    label: 'fields.engineering.commutator-maintenance.performed-maintenance-number',
    required: true,
    min: 0,
    max: 1000,
    maxLength: 4,
    maxLengthMask: 5,
  },
};
